import { render, staticRenderFns } from "./form-table.vue?vue&type=template&id=4795b876&lang=html&"
import script from "./form-table.vue?vue&type=script&lang=js&"
export * from "./form-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports